import React, {useState} from "react";
import { PageMeta } from "../../../Api/pagedata";
import {Helmet} from "react-helmet";
import { Link, useLocation } from "react-router-dom";
import Navbar from "../../../Components/Navbar/navbar";
import Footer from "../../../Components/Footer/footer";
import Findus from "../../../Components/Findus/findus";
import Clietns from "../../../Components/Ourclient/ourclient";
import { Modal, Button } from 'react-bootstrap';
import YouTube from 'react-youtube';
import { ReactComponent as Youtubeicon } from "../../../assets/images/youtubevideo.svg";

export default function Kidsdance(){
    const [isOpen, setIsOpen] = useState(false);
    const [videoId, setVideoId] = useState('');
    const handleClose = () => setIsOpen(false);
    const openModal = (id) => {
        setVideoId(id);
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
        setVideoId('');
    };
    const opts = {
        height: '500px',
        width: '100%',
        playerVars: {
            autoplay: 1, 
            rel: 0, 
        },
    };
    const [PageMetas, setPageMeta] = useState({});
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '');
    const secondSegment = pathSegments[0] || '';
    const fullURL = window.location.href;
    return(
        <React.Fragment>
            <PageMeta currentpageurl={secondSegment} onFetch={setPageMeta} />
            <Helmet>
                <title>{PageMetas.metatitle ? PageMetas.metatitle : 'Private Parties and lessons | Dance Embassy'}</title>
                <meta name="description" content={PageMetas.metadiscription || ''} />
                <meta name="keywords" content={PageMetas.metakeyword || ''} />
                <link rel="canonical" href={fullURL} />
            </Helmet>
            <Navbar/>
                <section className="breadcrumbarea">
                    <div className="container">
                        <div className="breadcrumhead">
                            <h1>Private Parties and lessons</h1>
                        </div>
                    </div>
                </section>
                <section className="kidsdance weddingdance">
                    <div className="container-fluid">
                        <div className="row g-0 align-items-center">
                            <div className="col-lg-6">
                                <div className="kidsvideo">
                                    <div className="getsocialbox">
                                        <img src="https://img.youtube.com/vi/URLFvtm7CDc/0.jpg" alt="YouTube Thumbnail" onClick={() => openModal('URLFvtm7CDc')} style={{ cursor: 'pointer' }} />
                                        <div className="videobtns" onClick={() => openModal('URLFvtm7CDc')}><Youtubeicon/></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="kidescontent">
                                    <p>Elevate your parties by wow-ing your guests with non-stop entertainment. Dance Embassy is an expert when it comes to executing talk of the town parties. Whether it’s an intimate Diwali gathering or a huge birthday or anniversary celebration, we offer a fantastic line of entertainment options for you to choose from.</p>
                                    <p>Our professional entertainers will come clad in dance costumes that are designed by our Founder, Lavania Rosie herself.</p>
                                    <p>Not only will our professional entertainers dish out a vibrant performance, they will also get your guests involved in the whole experience.</p>
                                    <p>Too busy to plan your event. Fret not! Dance Embassy works closely with a chosen and professional Events Company that can make your dream events a reality.</p>
                                    <div className="kidscta">
                                        <Link to="/contact-us/">Contact Us</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Modal show={isOpen} onHide={closeModal} centered size="lg" dialogClassName="video-popup">
                    <Modal.Body>
                        <div className="videopopupclose">
                            <Button variant="close" onClick={handleClose} aria-label="Close"></Button>
                        </div>
                        {videoId && <YouTube videoId={videoId} opts={opts} />}
                    </Modal.Body>
                </Modal>
            <Findus/>
            <Clietns/>
            <Footer/>
        </React.Fragment>
    )
}